import styles from "./styles.module.css";
import { BsXLg, BsSearch } from "react-icons/bs";


export default function CardFrota(props) {

    const frota = props.frota;
    const posicoes = props.frota.posicoes;

    function renderLabels() {
        return (
            posicoes.map((posicao) => {
                return (
                    <div>
                        <div>
                            {(posicao.tipo_pos === 'T' ? 'TITULAR ' + posicao.turno.turno : 'FOLGUISTA ' + posicao.turno.turno)}
                        </div>
                        <div className={styles.cardcomponent}>
                            <input type="text" className={styles.preenchido} value={posicao.pessoa_id} />
                            <div className={styles.btnsearch}>
                                <BsSearch size="16" />
                            </div>
                            <div className={styles.btnremove}>
                                <BsXLg color="#d03030" size="16" />
                            </div>
                        </div>
                    </div>
                )
            })
        )

    }

    function renderValues() {
        return (
            posicoes.map((posicao) => {
                return (
                    <div>
                        <div>
                            TRUNO {posicao.turno.turno}
                        </div>
                        <input type="text" className={styles.preenchido} value={posicao.turno.hr_inicio.substring(0,5)+' - '+posicao.turno.hr_fim.substring(0,5)} />
                    </div>
                )
            }
            )
        )

    }

    return (
        <>
            <div className={styles.cardfrota}>
                <div className={styles.header}>
                    FROTA {frota.cod_frota}
                </div>
                <div className={styles.cardcontent}>
                    <div className={styles.cardvalues}>
                        {renderValues()}
                        {/* <div>
                            <div>
                                TURNO1
                            </div>
                            <input type="text" className={styles.preenchido} value="07:00 - 14:00" />
                        </div>
                        <div>
                            <div>
                                TURNO2
                            </div>
                            <input type="text" className={styles.preenchido} value="14:00 - 22:00" />
                        </div>
                        <div>
                            <div>
                                TURNO3
                            </div>
                            <input type="text" className={styles.preenchido} value="22:00 - 07:00" />
                        </div>
                        <div>
                            <div>
                                TURNO1
                            </div>
                            <input type="text" className={styles.preenchido} value="07:00 - 14:00" />
                        </div>
                        <div>
                            <div>
                                TURNO2
                            </div>
                            <input type="text" className={styles.preenchido} value="14:00 - 22:00" />
                        </div>
                        <div>
                            <div>
                                TURNO3
                            </div>

                            <input type="text" className={styles.preenchido} value="22:00 - 07:00" />

                        </div> */}
                    </div>
                    <div className={styles.cardlabels}>
                        {renderLabels()}
                        {/* <div>
                            <div>
                                TITULAR 1
                            </div>
                            <div className={styles.cardcomponent}>
                                <input type="text" className={styles.preenchido} value="1234" />
                                <div className={styles.btnsearch}>
                                    <BsSearch size="16" />
                                </div>
                                <div className={styles.btnremove}>
                                    <BsXLg color="#d03030" size="16" />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                TITULAR 2
                            </div>
                            <div className={styles.cardcomponent}>
                                <input type="text" className={styles.preenchido} value="1234" />
                                <div className={styles.btnsearch}>
                                    <BsSearch size="16" />
                                </div>
                                <div className={styles.btnremove}>
                                    <BsXLg color="#d03030" size="16" />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                TITULAR 3
                            </div>
                            <div className={styles.cardcomponent}>
                                <input type="text" className={styles.preenchido} value="1234" />
                                <div className={styles.btnsearch}>
                                    <BsSearch size="16" />
                                </div>
                                <div className={styles.btnremove}>
                                    <BsXLg color="#d03030" size="16" />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                FOLGUISTA 1
                            </div>
                            <div className={styles.cardcomponent}>
                                <input type="text" className={styles.preenchido} value="1234" />
                                <div className={styles.btnsearch}>
                                    <BsSearch size="16" />
                                </div>
                                <div className={styles.btnremove}>
                                    <BsXLg color="#d03030" size="16" />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                FOLGUISTA 2
                            </div>
                            <div className={styles.cardcomponent}>
                                <input type="text" className={styles.preenchido} value="1234" />
                                <div className={styles.btnsearch}>
                                    <BsSearch size="16" />
                                </div>
                                <div className={styles.btnremove}>
                                    <BsXLg color="#d03030" size="16" />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                FOLGUISTA 3
                            </div>
                            <div className={styles.cardcomponent}>
                                <input type="text" className={styles.preenchido} value="1234" />
                                <div className={styles.btnsearch}>
                                    <BsSearch size="16" />
                                </div>
                                <div className={styles.btnremove}>
                                    <BsXLg color="#d03030" size="16" />
                                </div>
                            </div>
                        </div> */}
                    </div>


                </div>
            </div>
        </>
    )
}